module.exports = __webpack_public_path__ + "static/media/logo-cmtech-small.b5606ad6.png";